import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  ICSuserTrack,
  checkEmailValidation,
  checkPublicDomain,
  getExactURLValue,
  getURLValue,
  getUserGeolocationInfo,
  resendVerificationMail,
  userTrack,
} from "../Common.js";
import ErrorMassage from "../Band/Error.js";
import SuccessMassage from "../Band/Success.js";
import Button from "../Button.js";
import { P } from "../CommonStyle.js";
import RequestDemoField from "../RequestDemoFlow/RequestDemoField.js";
import Cookie from "js-cookie";
import { useRouter } from "next/router.js";

export const Wrap = styled.div`
  margin: 0 auto;
  width: 520px;
  text-align: center;
  position: absolute;
  top: 43%;
  transform: translate(0, -30%);
  margin-left: 75px;

  @media screen and (max-width: 767px) {
    top: auto;
    transform: none;
    margin-left: 20px;
    margin-top: 20px;
    width: auto;
    position: initial;
  }
`;
export const FormWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;
export const Header = styled.div`
  font-family: "Roboto";
  font-weight: 400;
  font-size: 48px;
  line-height: 42px;
  letter-spacing: -1.25px;
  color: #000000;
  margin-bottom: 10px;
  margin-top:45px;

  @media screen and (max-width: 1280px){
    margin-top: 45px;
  }

`;
export const SubHeader = styled.div`
  font-size: 16px;
  font-family: "Roboto";
  line-height: 16px;
  color: #454545;
  margin-bottom: 6px;
`;
export const Details = styled.div`
  margin-top: 0px;
`;
export const Label = styled.div`
  font-size: 16px;
  font-family: "Roboto";
  line-height: 24px;
  color: #352960;
  margin-top: 7px;
  text-align: left;

  @media screen and (max-width: 1280px){
    margin-top: 4px;
  }
`;
export const EmailFiled = styled.input`
  font-family: "Roboto";
  font-size: 15px;
  line-height: 24px;
  border: 1px solid rgba(149, 149, 149, 0.5);
  border-radius: 12px;
  padding: 13px 20px;
  margin-top: 10px;
  margin-bottom: 8px;
  width: 475px;
  color: #454545;
  background-color: #fff !important;
  -webkit-box-shadow: inset 0 0 0px 9999px white;

  &:focus {
    outline: none;
    border: 1px solid #ff7624;
  }

  @media screen and (max-width: 767px) {
    width: 290px;
  }
`;
export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 15px;

  @media screen and (max-width: 1280px){
      margin-top: 16px;
    margin-bottom: 5px;
  }
`;
export const LoginBtn = styled.button`
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-family: "Roboto";
  font-weight: 500;
  line-height: 20px;
  padding: 14px 40px;
  width: 145px;
  background-color: #2970b1;
  border: 1px solid #2970b1;
  border-radius: 4px;
  &:hover {
    background-color: #15436d;
    border: 1px solid #15436d;
    cursor: pointer;
  }
`;
export const ForgetPwd = styled.a`
  text-decoration: none;
  font-size: 12px;
  font-family: "Roboto";
  line-height: 24px;
  color: #2970b1;
  cursor: pointer;
  &:hover {
    color: #15436d;
  }
`;
export const NewAccount = styled.div`
  color: #acacac;
  font-size: 12px;
  font-family: "Roboto";
  line-height: 24px;
`;
export const InputError = styled.div`
  font-size: 14px;
  font-family: "Roboto";
  line-height: 21px;
  color: #ff4141;
  text-align: left;
  margin-bottom: 12px;
`;
const MrktAlertWrap = styled.div`
    background-color: #D4FFDE;
    width: 75%;
    height: 56px;
    position: fixed;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 40px;
    z-index: 100;
    box-shadow: 0px 30px 60px rgba(69, 69, 69, 0.25);
    left: 50%;
    top: 5%;
    transform: translate(-52%, -50%);

    @media screen and (max-width: 767px) {
      left: 45%;
      width: 90% !important;
    }
`;
const StyledSpan = styled.span`
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    color: rgb(31, 147, 110);
    cursor: auto;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 0px;
`;
const ClickSpan = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: #FF7624;
  /* background-color: transparent; */
  text-decoration: underline;
  cursor: pointer;
`;

const LoginForm = ({
  setIsLoading,
  isGuest,
  showSection,
  setShowSection,
  hasSession,
}) => {
  const { t } = useTranslation();

  const [signInError, setSignInError] = useState(null);
  const [signInSuccess, setSignInSuccess] = useState(null);
  const [userEmailError, setUserEmailError] = useState(null);
  const [userPasswordError, setUserPasswordError] = useState(null);
  const [resendBanner, setResendBanner] = useState(false);

  const [userEmail, setUserEmail] = useState(null);

  const userEmailRef = useRef(null);
  const userPasswordRef = useRef(null);

  const router = useRouter();

  const callUserNavigation = async (designId) => {
    const url = process.env.NEXT_PUBLIC_PLATFORM_API_URL + "/checksessionexists";
    const inputObj = {
      designid: designId,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(inputObj),
    });

    const data = await response.text();

    const navURL = process.env.NEXT_PUBLIC_SERVER_NAME_URL + data;

    window.location.href = navURL;
    // window.history.replaceState({}, '', navURL);
    // window.location.reload();
  };

  useEffect(() => {
    // to navigate guest user to design when session is there ==================
    const designId = getURLValue("designid");
    if (hasSession && designId) {
      callUserNavigation(designId);
      return;
    }
    // ============================
  }, [hasSession]);

  useEffect(() => {
    const email = getExactURLValue("email");
    if (email && userEmailRef) {
      userEmailRef.current.value = email;
    } else if (userEmailRef) {
      let FormEmailAutofill = JSON.parse(
        localStorage.getItem("subscribeformdetails")
      );
      // Check if FormEmailAutofill is not null and is an object
      if (
        FormEmailAutofill &&
        typeof FormEmailAutofill === "object" &&
        Object.keys(FormEmailAutofill).length > 0
      ) {
        userEmailRef.current.value =
          FormEmailAutofill.email || FormEmailAutofill.emailId || "";
      }
    }
  }, []);

  useEffect(() => {
    if (signInError != null) {
      setTimeout(() => {
        setSignInError(null);
      }, 4000);
    }
  }, [signInError]);

  useEffect(() => {
    if (signInSuccess != null) {
      setTimeout(() => {
        setSignInSuccess(null);
      }, 4000);
    }
  }, [signInSuccess]);

  const resetErrors = () => {
    setUserEmailError(null);
    setUserPasswordError(null);
  };

  const setError = (field, message) => {
    resetErrors();
    switch (field) {
      case "email":
        setUserEmailError(message);
        break;
      case "password":
        setUserPasswordError(message);
        break;
      default:
        break;
    }
  };

  const handleEnterClick = (event) => {
    if (event.key == "Enter") {
      loginHandler();
    }
  };

  const checkGuestInfo = async (emailId) => {
    setIsLoading(true);
    resetErrors();

    try {
      await ICSuserTrack(
        emailId,
        "Clicked on Continue as Guest button",
        "/signin.html",
        "Guest login",
        "",
        Cookie.get("accessid")
      );
      await ICSuserTrack(
        emailId,
        `User gives - Your Work Email Id ${emailId}`,
        "/signin.html",
        "Guest login",
        "",
        Cookie.get("accessid")
      );
    } catch (error) {
      console.error("error while calling activity", error);
    }
    let userIP = "";
    let geoLocation = "";
    let geoPortal = "";
    const userLocationDetails = await getUserGeolocationInfo();
    if (userLocationDetails) {
      if (userLocationDetails.usripaddress) {
        userIP = userLocationDetails.usripaddress;
      }
      if (userLocationDetails.usrgeolocation) {
        geoLocation = userLocationDetails.usrgeolocation;
      }
      if (userLocationDetails.usergeoportal) {
        geoPortal = userLocationDetails.usergeoportal;
      }
    }

    const guestURL =
      process.env.NEXT_PUBLIC_PLATFORM_API_URL + "/checkguestexist";
    const guestInput = {
      workemaild: emailId,
      geoportal: geoPortal,
      geolocation: geoLocation,
    };

    const response = await fetch(guestURL, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(guestInput),
    });

    const result = await response.text();

    switch (result) {
      case "login to access":
        navigateToLogin();
        return;

      case "guest exist":
      case "guest account created":
        await sendVerificationCode(emailId, userIP);
        return;
    }
  };

  const sendVerificationCode = async (emailId, userIP) => {
    const url =
      process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL +
      "/rdt/cesreport/mailverification";
    const inputObj = {
      type: "GuestLogin",
      email: emailId,
      ipAddress: userIP,
      reportId: null,
      isMail: "N",
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(inputObj),
    });

    const result = await response.json();

    if (result.status == "verification code has been sent") {
      const designId = getExactURLValue("designid");
      let navURL = `/guestloginverification.html?key=${btoa(emailId)}`;
      if (designId) {
        navURL = `/guestloginverification.html?key=${btoa(
          emailId
        )}&designid=${designId}`;
      }
      window.location.href = navURL;
    } else {
      setSignInError("Something went wrong!, Please try again");
      setIsLoading(false);
    }
  };

  const navigateToLogin = () => {
    setShowSection("login");
    setIsLoading(false);
    setSignInError(
      "You already have an account with Ideapoke. Please login to continue."
    );
  };

  const loginHandler = () => {
    const email = userEmailRef.current.value.trim();

    if (email === "") {
      setError("email", t("emailRequired"));
      return;
    } else if (!checkEmailValidation(email)) {
      setError("email", t("validEmail"));
      return;
    } else if (checkPublicDomain(email)) {
      setError("email", t("enterWorkEmail"));
      return;
    }

    if (isGuest && showSection == "guest") {
      checkGuestInfo(email);
      return;
    }

    const password = userPasswordRef.current.value.trim();
    if (password === "") {
      setError("password", t("passwordRequired"));
      return;
    } else if (password.length < 6) {
      setError("password", t("passwordMinLength"));
      return;
    } else if (password.length > 16) {
      setError("password", t("passwordMaxLength"));
      return;
    }

    resetErrors();
    setUserEmail(email);

    //Take value from url
    const targetUrl = router?.query?.url || "";

    let geoLocation = "unknown";
    let geoUseragent = "unknown";
    let geoPortal = "unknown";
    const userLocationDetails = getUserGeolocationInfo();
    if (userLocationDetails) {
      geoLocation = userLocationDetails.usrgeolocation;
      geoUseragent = userLocationDetails.usergeouseragent;
      geoPortal = userLocationDetails.usergeoportal;
    }

    // const url = "https://ideastage.in/designloginaction";
    const url = process.env.NEXT_PUBLIC_PLATFORM_API_URL + "/designloginaction";

    const inputObject = {
      emailid: email,
      password: password,
      geolocation: geoLocation,
      geoportal: geoPortal,
      geouseragent: geoUseragent,
      targetUrl: targetUrl,
      token: null,
      actiontype: "",
    };

    const msgkey = getExactURLValue("key");
    const designId = getURLValue("designid");

    if (designId) {
      inputObject.designid = designId;
    }
    if (msgkey && msgkey.trim() != "") {
      inputObject.messagekey = msgkey;
    } else {
      inputObject.messagekey = "DESIGNUSERSIGNIN";
    }
    callSingInAPI(url, inputObject, email);
  };

  const callSingInAPI = async (url, inputObj, email) => {
    setIsLoading(true);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(inputObj),
    });

    const data = await response.json();
    setIsLoading(false);

    switch (data[0].identifier) {
      case "User record not found":
        setSignInError("Incorrect E-mail ID or password");
        return;
      case "User deactivated":
        setSignInError("User deactivated from platform. Contact Ideapoke team");
        return;
      case "User Mail Verification Pending":
        setResendBanner(true);
        return;
      case "Analyst Verification Pending":
        window.location.href = "/verifyaccount.html";
        return;
      case "Analyst Verification Rejected":
        window.location.href = "/accessdenied.html";
        return;
    }

    await userTrack(`${email}`, "Clicked on log in button", "/signin");
    console.log(
      "navigation url-->",
      process.env.NEXT_PUBLIC_API_URL + data[0].url
    );
    window.location.href = process.env.NEXT_PUBLIC_API_URL + data[0].url;
  };

  const resendMail = async () => {
    if (userEmail) {
      const result = await resendVerificationMail(userEmail);
      if (result == "true") {
        setResendBanner(false);
        setSignInSuccess("A new verification email has been sent!");
      } else {
        setSignInError("Unable to resend, Please try again");
      }
    } else {
      setSignInError("Unable to resend, Please try again");
    }
  };

  return (
    <div>
      {signInError && <ErrorMassage width="60%" message={signInError} />}
      {signInSuccess && <SuccessMassage message={signInSuccess} />}
      {resendBanner && (
        <MrktAlertWrap style={{ width: "65%", height: "70px" }}>
          <div>
            <div>
              <P
                text={"Your sign up request is pending verification."}
                color="#1F936E"
                fontSize="18px"
                fontWeight="bold"
                cursor="auto"
              ></P>
            </div>
            <div style={{ marginLeft: "50px" }}>
              <StyledSpan>Click to </StyledSpan>
              <ClickSpan onClick={resendMail}>
                resend verification email.
              </ClickSpan>
            </div>
          </div>
        </MrktAlertWrap>
      )}

      <Wrap>
        <FormWrap>
          <Header>Login</Header>
          <SubHeader>To see your research come alive!</SubHeader>

          {isGuest && (
            <RequestDemoField
              showSection={showSection}
              setShowSection={setShowSection}
              resetErrors={resetErrors}
              userEmailRef={userEmailRef}
            />
          )}

          <Details>
            <div>
              <Label>
                {showSection == "guest"
                  ? "Your Work Email ID"
                  : "Email address"}{" "}
                <span style={{ color: "red" }}> *</span>
              </Label>
              <EmailFiled
                ref={userEmailRef}
                placeholder="Enter your email"
                type="email"
                onKeyPress={handleEnterClick}
              ></EmailFiled>
              {userEmailError && <InputError>{userEmailError}</InputError>}
            </div>
            {showSection == "login" && (
              <div>
                <Label>
                  Password <span style={{ color: "red" }}> *</span>
                </Label>
                <EmailFiled
                  type="password"
                  placeholder="Enter your password "
                  ref={userPasswordRef}
                  onKeyPress={handleEnterClick}
                ></EmailFiled>
                {userPasswordError && (
                  <InputError>{userPasswordError}</InputError>
                )}
              </div>
            )}
          </Details>
        </FormWrap>

        <BtnWrap>
          <Button
            text={showSection == "guest" ? "Continue as Guest" : "Log In"}
            variant="solidOrange"
            onClick={loginHandler}
            width={showSection == "guest" ? "200px" : "100px"}
            height="50px"
          ></Button>
          {/* <LoginBtn onClick={loginHandler}>Log In</LoginBtn> */}
        </BtnWrap>

        {showSection == "login" && (
          <div>
            <ForgetPwd href="/forgotpassword.html">Forgot Password?</ForgetPwd>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                justifyContent: "center",
              }}
            >
              <NewAccount>Don’t have an account? </NewAccount>
              <ForgetPwd href="/signup.html">Sign Up</ForgetPwd>
            </div>
          </div>
        )}
      </Wrap>
    </div>
  );
};

export default LoginForm;
